"use strict";

var _toConsumableArray = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var SVGElementImpl = require("./SVGElement-impl").implementation;

var SVGTestsImpl = require("./SVGTests-impl").implementation;

var SVGGraphicsElementImpl =
/*#__PURE__*/
function (_SVGElementImpl) {
  _inherits(SVGGraphicsElementImpl, _SVGElementImpl);

  function SVGGraphicsElementImpl() {
    _classCallCheck(this, SVGGraphicsElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SVGGraphicsElementImpl).apply(this, arguments));
  }

  return SVGGraphicsElementImpl;
}(SVGElementImpl);

SVGGraphicsElementImpl.attributeRegistry = new Map([].concat(_toConsumableArray(SVGElementImpl.attributeRegistry), _toConsumableArray(SVGTestsImpl.attributeRegistry)));
mixin(SVGGraphicsElementImpl.prototype, SVGTestsImpl.prototype);
exports.implementation = SVGGraphicsElementImpl;